import React__default from 'react';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { CLPrescriptionColumnContainer } from './components/CLPrescriptionColumn/CLPrescriptionColumnContainer.js';

const CLPrescriptionSelector = ({ prescriptionAttributesSet  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "cl-prescription-selector"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, getLabel('products.contactLenses.prescription.title')), /*#__PURE__*/ React__default.createElement("div", {
        className: "cl-prescription-selector__grid"
    }, /*#__PURE__*/ React__default.createElement(CLPrescriptionColumnContainer, {
        eyeSideId: "right",
        "data-t": "prescription-right-eye",
        parameters: prescriptionAttributesSet,
        className: "cl-prescription-selector__column cl-prescription-selector__column--right",
        columnTitle: getLabel(`products.contactLenses.rightEye`)
    }), /*#__PURE__*/ React__default.createElement(CLPrescriptionColumnContainer, {
        eyeSideId: "left",
        "data-t": "prescription-left-eye",
        parameters: prescriptionAttributesSet,
        className: "cl-prescription-selector__column cl-prescription-selector__column--left",
        columnTitle: getLabel(`products.contactLenses.leftEye`)
    })));
};

export { CLPrescriptionSelector };
//# sourceMappingURL=CLPrescriptionSelector.js.map
